import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import CountUp from "react-countup";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";

import { withFormik } from "formik";
import * as Yup from "yup";

// Material Dashboard 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MDBadge from "components/MDBadge";
import MKButton from "components/MKButton";

import DataTable from "examples/Tables/DataTable";

// Images
import brandDark from "assets/images/logo-ct-dark.png";

// import AddonSection from "layouts/policy-management-details/AddonSection";

import { getSinglePolicy } from "actions/policyActions";
import { getOrderSingle } from "actions/orderActions";

function PolicyForm({ ...props }) {
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [deselectedAddons, setDeselectedAddons] = useState([]);

  const {
    isSubmitting,
    values = [],
    touched,
    handleSubmit,
    handleChange,
    handleBlur,
    errors,
    setFieldTouched,
    setFieldValue,
    setFieldError,
  } = props;
  const dispatch = useDispatch();
  const { id } = useParams();

  const orderSingle = useSelector((state) => state.orderSingle);
  const { singleOrder } = orderSingle;
  console.log(
    "🚀 ~ file: index.js:56 ~ PolicyForm ~ singleOrder:",
    singleOrder
  );

  useEffect(() => {
    dispatch(getOrderSingle(id));
  }, [dispatch, singleOrder?.length, id]);

  useEffect(() => {
    const localAddons = JSON.parse(localStorage.getItem("selectedAddons"));
    let currentAddons = singleOrder?.policy?.addons?.filter((item) =>
      localAddons?.some((addonItem) => addonItem?._id === item?._id)
    );
    setSelectedAddons(currentAddons);
    let nonCurrentAddons = singleOrder?.policy?.addons?.filter(
      (item) => !localAddons?.some((addonItem) => addonItem?._id === item?._id)
    );
    setDeselectedAddons(nonCurrentAddons);
  }, [dispatch, singleOrder?.policy?._id, id]);

  const getGrandTotal = () => {
    const addonsTotal = selectedAddons?.reduce((acc, item) => {
      return acc + item.addonAmount;
    }, 0);
    return addonsTotal + singleOrder?.policy?.premiumAmount;
  };

  return (
    <>
      <MKBox mt={6} mb={1}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12} md={12}>
            <Card>
              <MKBox p={5} lineHeight={0}>
                <MKBox display="flex" justifyContent="space-between">
                  <MKBox display="flex" alignItems="center">
                    <MKBox
                      component="img"
                      src={brandDark}
                      alt="Brand"
                      width="5rem"
                    />
                  </MKBox>

                  <MKBox display="flex" alignItems="center">
                    <MKBox
                      component="img"
                      src={singleOrder?.company?.companyLogo}
                      alt="Brand"
                      width="5rem"
                    />
                  </MKBox>
                </MKBox>

                <MKBox display="flex" justifyContent="space-between" mb={10}>
                  <MKBox>
                    <MKTypography variant="h6">Somosure Insurance</MKTypography>
                    <MKTypography variant="h6">Nairobi, Kenya</MKTypography>
                    <MKTypography variant="h6">
                      Email:{" "}
                      <MKTypography
                        variant="body"
                        fontSize="medium"
                        color="text"
                        fontWeight="regular"
                      >
                        somsure@mail.com
                      </MKTypography>
                    </MKTypography>
                    <MKTypography variant="h6">
                      Phone:{" "}
                      <MKTypography
                        variant="body"
                        fontSize="medium"
                        color="text"
                        fontWeight="regular"
                      >
                        +254 700 112344
                      </MKTypography>
                    </MKTypography>
                  </MKBox>

                  <MKBox textAlign="right">
                    <MKTypography variant="h6">
                      {singleOrder?.company?.companyName}
                    </MKTypography>
                    <MKTypography variant="h6">
                      {singleOrder?.company?.companyAddress}
                    </MKTypography>
                    <MKTypography variant="h6">
                      Email:{" "}
                      <MKTypography
                        variant="body"
                        fontSize="medium"
                        color="text"
                        fontWeight="regular"
                      >
                        {singleOrder?.company?.companyEmail}
                      </MKTypography>
                    </MKTypography>
                    <MKTypography variant="h6">
                      Phone:{" "}
                      <MKTypography
                        variant="body"
                        fontSize="medium"
                        color="text"
                        fontWeight="regular"
                      >
                        {singleOrder?.company?.companyPhone}
                      </MKTypography>
                    </MKTypography>
                  </MKBox>
                </MKBox>

                <MKBox display="flex" justifyContent="space-between" mb={5}>
                  <MKBox>
                    <MKTypography variant="h6">Order No.</MKTypography>
                    <MKTypography
                      variant="button"
                      color="text"
                      fontWeight="regular"
                    >
                      #{singleOrder?._id}
                    </MKTypography>
                  </MKBox>

                  <MKBox textAlign="right">
                    <MKTypography variant="h6">
                      Created:{" "}
                      <MKTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {moment(singleOrder?.policy?.created_at).format(
                          "DD/MM/YYYY"
                        )}
                      </MKTypography>
                    </MKTypography>
                    <MKTypography variant="h6">
                      Category:{" "}
                      <MKTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {singleOrder?.category?.mainCategory} -{" "}
                        {singleOrder?.category?.category}
                      </MKTypography>
                    </MKTypography>
                  </MKBox>
                </MKBox>

                <MKBox p={3} mb={5}>
                  <DataTable
                    table={{
                      columns: [
                        {
                          Header: "Description",
                          accessor: "description",
                          width: "30%",
                          align: "left",
                        },
                        {
                          Header: "Insured Items",
                          accessor: "insuredItems",
                          width: "30%",
                          align: "left",
                        },

                        {
                          Header: "Premium Amount",
                          accessor: "premiumAmount",
                          width: "20%",
                          align: "center",
                        },
                        {
                          Header: "Active",
                          accessor: "active",
                          width: "10%",
                          align: "center",
                        },
                      ],

                      rows: [
                        {
                          description: (
                            <MKBox maxWidth={300}>
                              <MKTypography
                                variant="caption"
                                color="text"
                                fontWeight="medium"
                              >
                                {singleOrder?.policy?.description}
                              </MKTypography>
                            </MKBox>
                          ),
                          insuredItems: (
                            <MKBox display="flex" flexDirection="column">
                              {singleOrder?.policy?.insuredItems?.map(
                                (item, index) => (
                                  <MKTypography
                                    key={index}
                                    variant="caption"
                                    color="text"
                                    fontWeight="medium"
                                    mb={1}
                                  >
                                    ({index + 1}) {item}
                                  </MKTypography>
                                )
                              )}
                            </MKBox>
                          ),
                          premiumAmount: (
                            <MKTypography
                              variant="caption"
                              color="text"
                              fontWeight="medium"
                            >
                              Ksh. {singleOrder?.policy?.premiumAmount}
                            </MKTypography>
                          ),
                          active: (
                            <MKTypography
                              variant="caption"
                              color="text"
                              fontWeight="medium"
                            >
                              {singleOrder?.policy?.active ? (
                                <MKBox ml={-1}>
                                  <MDBadge
                                    badgeContent="active"
                                    color="dark"
                                    variant="gradient"
                                    size="sm"
                                  />
                                </MKBox>
                              ) : (
                                <MKBox ml={-1}>
                                  <MDBadge
                                    badgeContent="inactive"
                                    color="success"
                                    variant="gradient"
                                    size="sm"
                                  />
                                </MKBox>
                              )}
                            </MKTypography>
                          ),
                        },
                      ],
                    }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MKBox>

                <Grid container spacing={3} px={3}>
                  <Grid item xs={12} md={6} lg={6} sx={{ p: 1 }}>
                    <MKTypography variant="h6">Chosen Addons</MKTypography>
                  </Grid>
                </Grid>
                {/* <Grid container spacing={3} px={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <FormControl component="fieldset" variant="standard">
                      <FormGroup>
                        {singleOrder?.addons?.map((item, index) => (
                          <Tooltip
                            key={index}
                            title={item?.description}
                            arrow
                            placement="right"
                            disableInteractive
                          >
                            <MKBox display="flex">
                              <MKTypography
                                variant="body2"
                                color="text"
                                fontWeight="regular"
                              >
                                {item?.addonName}
                              </MKTypography>
                              <MKTypography
                                variant="body2"
                                color="text"
                                fontWeight="medium"
                                pl={2}
                              >
                                {"( + Ksh."}
                                {item?.addonAmount}
                                {")"}
                              </MKTypography>
                            </MKBox>
                          </Tooltip>
                        ))}
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <FormControl component="fieldset" variant="standard">
                      <FormGroup>
                        {singleOrder?.addons?.map((item, index) => (
                          <FormControlLabel
                            key={index}
                            control={
                              <Switch
                                checked={singleOrder?.addons?.some(
                                  (addon) => addon.addonName === item.addonName
                                )}
                                onChange={(event) => handleChange(event, item)}
                                name={item.addonName}
                              />
                            }
                            label={
                              <Tooltip
                                title={item?.description}
                                arrow
                                placement="right"
                                disableInteractive
                              >
                                <MKBox display="flex">
                                  <MKTypography
                                    variant="body2"
                                    color="text"
                                    fontWeight="regular"
                                  >
                                    {item?.addonName}
                                  </MKTypography>
                                  <MKTypography
                                    variant="body2"
                                    color="text"
                                    fontWeight="medium"
                                    pl={2}
                                  >
                                    {"( + Ksh."}
                                    {item?.addonAmount}
                                    {")"}
                                  </MKTypography>
                                </MKBox>
                              </Tooltip>
                            }
                          />
                        ))}
                      </FormGroup>
                    </FormControl>
                  </Grid>
                </Grid> */}

                <MKBox display="flex" justifyContent="space-between" m={5}>
                  <MKBox py={5}>
                    <MKTypography variant="body2" color="text">
                      * Amount exclusive of tax
                    </MKTypography>
                  </MKBox>
                  <MKBox textAlign="flex-end" mr={5}>
                    <MKBox
                      display="flex"
                      flexDirection="row"
                      py={1}
                      justifyContent="flex-end"
                      alignItems="flex-end"
                    >
                      <MKTypography variant="body2" color="text">
                        Policy Total:{" "}
                      </MKTypography>
                      <MKTypography variant="h5" pl={3}>
                        Ksh. {singleOrder?.policy?.premiumAmount}
                      </MKTypography>
                    </MKBox>
                    <MKBox
                      display="flex"
                      flexDirection="row"
                      py={1}
                      justifyContent="flex-end"
                      alignItems="flex-end"
                    >
                      <MKTypography variant="body2" color="text">
                        Total + Addons:{" "}
                      </MKTypography>
                      <MKTypography variant="h5" pl={3}>
                        Ksh. {getGrandTotal()}
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                </MKBox>
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </MKBox>
      <Grid container spacing={0} direction="row" justify="flex-end">
        <Grid item md={11} lg={11} />
        <Grid item md={1} lg={1}>
          <MKButton
            onClick={handleSubmit}
            disabled={isSubmitting || Object.entries(errors).length > 0}
            type="submit"
          >
            Next
          </MKButton>
        </Grid>
      </Grid>
    </>
  );
}

const PolicyStep = withFormik({
  mapPropsToValues: (props) => (props.values !== undefined ? props.values : []),
  // validationSchema: RecipeSchema,
  handleSubmit: (values, { props }) => {
    // console.log("🚀 ~ file: index.js:473 ~ values:", values);
    props.next([]);
  },
  enableReinitialize: true,
  displayName: "PolicyStep",
})(PolicyForm);

export default PolicyStep;
